import { httpRequest } from "@services/http";
import type { MarginSummary } from "../opsDashboard.types";

/**
 * Margin Tracking's stat tiles and trend (MPN-1861).
 *
 * Takes no filters on purpose. The design's 87% is a PORTFOLIO target, and a blended
 * margin over whatever subset the page is filtered to is not the number it was set
 * against.
 */
export class CommandGetOpsMargin {
    async run(): Promise<MarginSummary> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/ops-dashboard/margin`;
        return await httpRequest<MarginSummary>(url, { method: "GET" });
    }
}
